import { StyleSheet } from "react-native"
import { appColors, appFonts, fontSize } from "../../appTheme"

export const addEditTimeCardStyle = StyleSheet.create({

    container: {
        flex: 1
    },
    labelStyle: {
        fontSize: fontSize.tinyFontSize,
        color: appColors.labelColor
    },
    inputStyle: {
        fontSize: fontSize?.tinyFontSize,
        color: appColors?.dark,
        fontFamily: appFonts?.medium
    },
    buttonView: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginRight: 20,
    },


})